import { PriceOptionsActionTypes } from './types';

export const changeShowTotalPrice = (
  showTotalPrice: boolean,
  isInit?: boolean,
): { type: PriceOptionsActionTypes; payload: { updatedValue: boolean; isInit: boolean } } => ({
  type: PriceOptionsActionTypes.ChangeShowTotalPrice,
  payload: { updatedValue: showTotalPrice, isInit: isInit === undefined ? true : isInit },
});

export const changeIsIncludingTaxOrFee = (
  isIncludingTaxOrFee: boolean,
  isInit?: boolean,
): { type: PriceOptionsActionTypes; payload: { updatedValue: boolean; isInit?: boolean } } => ({
  type: PriceOptionsActionTypes.ChangeIsIncludingTaxOrFee,
  payload: { updatedValue: isIncludingTaxOrFee, isInit: isInit === undefined ? true : isInit },
});
